import React from 'react'
import { Query } from 'react-apollo'
import { GET_PROJECTS } from '../../graphql/queries'

const GetProjects = (WrappedComponent, fetchPolicy = 'cache-first') => {
  return class extends React.PureComponent {
    render() {
      return (
        <Query query={GET_PROJECTS}
          variables={{ id: this.props.match.params.projectId }}
          fetchPolicy={fetchPolicy}>
          {({ loading, error, data }) => {
            if (loading) {
              return null
            }

            if (error) {
              return `Error! ${error.message}`
            }

            if (data.getProject === null) {
              return <h1 style={{color: 'white', textAlign: 'center'}}>404</h1>
            }

            return (
              <WrappedComponent {...this.props} projects={data.getProjects} />
            )
          }}
        </Query>
      )
    }
  }
}

export default GetProjects

export const GetProjectsRefreshed = (WrappedComponent) => {
  return GetProjects(WrappedComponent, 'network-only')
}
